export default "__VITE_ASSET__b06866e0__"